"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalSourceUpdateContract = exports.ExternalSourceEventDataContract = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
const models_1 = require("./models");
class ExternalSourceEventDataContract {
}
exports.ExternalSourceEventDataContract = ExternalSourceEventDataContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "hexColor", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "logoImageUrl", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(models_1.ExternalSourceCategoryNames),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "categoryName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "setupUrl", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "homepage", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "isEnabled", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)()
], ExternalSourceEventDataContract.prototype, "permissions", void 0);
class ExternalSourceUpdateContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.externalSource = events_1.GreenlineEvent.create(ExternalSourceEventDataContract, params.externalSource);
    }
}
exports.ExternalSourceUpdateContract = ExternalSourceUpdateContract;
//# sourceMappingURL=events.js.map